// extracted by mini-css-extract-plugin
module.exports = {"fullcontainer":"fullsectionContainer_fullcontainer__OcmWs","heading":"fullsectionContainer_heading__1Ke5q","blue":"fullsectionContainer_blue__2bYe9"};